import { createPopper } from '@popperjs/core';//https://popper.js.org/
import flip from '@popperjs/core/lib/modifiers/flip.js';

/**
 * Adds InfoTooltip functionality to element
 */
export default class InfoTooltip {

  /**
   * @property {HTMLElement} element - component's element
   */
  #element;

  /**
   * @property {HTMLElement} source - source element, usually a link
   */
  #source;

  /**
   * @property {object} instances - all instances of InfoTooltip class, key is element's id and value is instance of InfoTooltip
   */
  static instances = {};

  /**
   * @constructor
   * @param {HTMLElement} element element to where to bind info toolip logic
   * @param {HTMLElement} source source element, usually a link
   */
  constructor(element, source) {
    this.#element = element;
    this.#source = source;
    this.#bindEventListeners();

    const popperModifiers = [flip];

    if( this.#source.dataset.infotooltipOffset ) {
      popperModifiers.push({name: 'offset', options: { offset: JSON.parse(this.#source.dataset.infotooltipOffset) } })
    }

    createPopper( this.#source, this.#element,{
      modifiers: popperModifiers
    })

    InfoTooltip.instances[ element.id ] = this;
  }

  /**
   * Accessor for a element
   * @return {HTMLElement} element
   */
  get element() {
    return this.#element;
  }

  /**
   * Show or hides element
   * @param {boolean} enabled true to show the element false to hide it
   */
  set show(enabled) {
    this.#element.classList.toggle('show', enabled);
  }

  /**
   * Bind event listener for element
   */
  #bindEventListeners() {
    window.addEventListener('click', this.#onDocumentClicked.bind(this));
    this.#source.addEventListener('keydown', this.#onEscapePressed.bind(this));
    this.#source.addEventListener('blur', this.#onBlur.bind(this));
  }

  /**
   * Closes tooltips when a document is clicked elsewhere
   * @param {Event} event event object
   */
  #onDocumentClicked(event) {
    if ( event.target.tagName !== 'A' && !event.target.dataset.infotooltipTarget && !event.target.closest('.info-tooltip')) {
      this.show = false;
    }
  }

  #onEscapePressed(event) {
    if(event.code === 'Escape') {
      this.show = false;
    }
  }

  /**
   * When a InfoTooltip source button loses focus.
   * @param {Event} event actual event object
   */
  #onBlur(event) {
    this.show = false;
  }

  /**
   * Initializes popups
   */
  static init() {
    const tooltipLinks = document.querySelectorAll('[data-infotooltip-target]');

    //Lazy load tooltip only after link is actually clicked
    tooltipLinks.forEach( (button) => {

      button.addEventListener('click', event => {

        event.preventDefault();
        event.stopPropagation();

        if (event.target.nodeName !== 'BUTTON') {
          console.error('InfoTooltip buttons need to be <button> elements.')
          return;//Don't event try.. but don't brake whole page either.
        }

        const target = event.target.dataset.infotooltipTarget;
        let instance = InfoTooltip.instances[ target ];

        if( !instance ) {
          const tooltipTarget = document.querySelector( target );
          if( tooltipTarget ) {
            instance = new InfoTooltip( tooltipTarget, event.target );
          }
        }

        if( instance ) {
          instance.show = true;
        }
      });
    });
  }
}

